/* istanbul ignore file */
import React, { useEffect } from 'react';
import { get, isEmpty } from 'lodash';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import { IntlShape, injectIntl } from 'react-intl';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardTitle from 'containers/common/Card/CardTitle';
import { connect, useSelector } from 'react-redux';
import TablePagination from '@material-ui/core/TablePagination';
import { Container } from 'containers/ManagerManagement/styles';
import { translate } from 'containers/services/translate';
import messages from 'containers/IntervenantManagement/messages';
import { ROW_PER_PAGE } from 'constants/global';
import {
  makeSelectMappingLawyers,
  makeSelectMappingLawyer,
} from 'containers/IntervenantManagement/selectors';
import { requestSetPrivilegesManager } from 'containers/ManagerManagement/actions';
import {
  requestGetMappingLawyers,
  requestCreateIntervenantKeycloak,
  requestUpdateMappingLawyers,
  requestSearchMappingLawyers,
  requestGetMappingLawyer,
} from 'containers/IntervenantManagement/actions';
import { makeSelectListings } from 'containers/AppContainer/selectors';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import {
  getWorkingPeriods,
  formatObject,
} from 'containers/IntervenantManagement/utils';
import DrawerAddMapping from 'containers/IntervenantManagement/DrawerAddIntervenantMapping';
import DrawerUpdateMapping from 'containers/IntervenantManagement/DrawerUpdateIntervenants';
import { isDesactivateIntervenant } from 'services/utils';
import { Button } from '@material-ui/core';
import AddIntervenantDialog from 'containers/IntervenantManagement/AddIntervenantDialog';
import { requestCorporealLawyers } from 'containers/RecapManagerPage/actions';
import { makeSelectCorporealLawyers } from 'containers/RecapManagerPage/selectors';
import { STAKE_HOLDERS_TYPES } from 'containers/CourtManagerLegalProceedings/Provision/constants';
import SearchBar, {
  SearchQuery,
} from 'containers/IntervenantManagement/SearchBar';
import { SEARCH_QUERY_INIT_VALUES } from 'containers/IntervenantManagement/constants';
import * as util from 'containers/RecapManagerPage/utils';
import { ITEM_KEYS, SAGIS_KEYS } from 'containers/RecapManagerPage/constants';
import { LISTINGS } from 'containers/data-structure';
import { SagisConfig } from 'containers/AppContainer/typings';

export interface IntervenantManagementProps {
  intl: IntlShape;
  requestGetMappingLawyers: Function;
  requestSetPrivilegesManager: Function;
  requestCorporealLawyers: Function;
  requestCreateIntervenantKeycloak: Function;
  requestUpdateMappingLawyers: Function;
  requestSearchMappingLawyers: Function;
  requestGetMappingLawyer: Function;
}

export const IntervenantManagement: React.FC<IntervenantManagementProps> = (
  props,
): JSX.Element => {
  const [page, setPage] = React.useState(0);
  const [pageSize, setRowsPerPage] = React.useState(25);
  const [openDrawerUpdate, setOpenDrawerUpdate] = React.useState(false);
  const [openDrawerAdd, setOpenDrawerAdd] = React.useState(false);

  const [openDialogAddIntervenant, setAddDialogAddIntervenant] = React.useState(
    false,
  );
  const [corpoLawyers, setCorpoLawyers] = React.useState([]);

  const [searchQuery, setSearchQuery] = React.useState<SearchQuery>(
    SEARCH_QUERY_INIT_VALUES,
  );
  const mappingLawyer = useSelector(makeSelectMappingLawyer());
  const [lawyersToAdd, setlawyersToAdd] = React.useState<any[]>([]);
  const [selectedRow, setSelectedRow] = React.useState({});
  const mappingLawyers = useSelector(makeSelectMappingLawyers());
  const listings = useSelector(makeSelectListings());
  const lawyers = useSelector(makeSelectCorporealLawyers());
  const [hasFetchedMapping] = React.useState(false);

  useEffect(() => {
    props.requestCorporealLawyers();
  }, []);
  useEffect(() => {
    props.requestGetMappingLawyers(page, pageSize);
    getUnmappedLawyers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize]);

  useEffect(() => {
    const _stackholders = util.getListBySagisKey(
      get(listings, LISTINGS.STACKHOLDER_TYPE, []),
      get(listings, LISTINGS.STACKHOLDERS, []),
      ITEM_KEYS.LAWYER,
      SAGIS_KEYS.ITEM_TYPE as keyof SagisConfig,
    );
    const lawyersCorpo = util.getBawabaLawyers(_stackholders, lawyers);
    setCorpoLawyers(lawyersCorpo as any);
    if (!isEmpty(lawyersCorpo) && !hasFetchedMapping) {
      props.requestGetMappingLawyer({
        lawyerCodes: lawyersCorpo.map((el: any) => el.ItemKey),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!listings, !isEmpty(lawyers), !isEmpty(mappingLawyers)]);

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const size = parseInt(event.target.value, 10);
    setRowsPerPage(size);
  };

  const handleCloseDialogIntervenant = () => {
    setAddDialogAddIntervenant(false);
  };
  const getUnmappedLawyers = () => {
    const lawyer_sagis_code = get(listings, 'intervenants', []).filter(
      (el: any) => el.ItemType === STAKE_HOLDERS_TYPES.LAWYER,
    );

    const existingCodes = lawyers
      .map((lawyer: any) => {
        return lawyer.attributes?.sagis_code?.[0];
      })
      .filter((code: any) => code);
    const lawyersToAdd = lawyer_sagis_code.filter((localLawyer: any) => {
      return !existingCodes.includes(localLawyer.ItemKey);
    });
    setlawyersToAdd(lawyersToAdd);
  };

  const getTotalDays = (row: any) => {
    return Object.entries(row).filter(
      ([key]) => key.startsWith('day') && row[key],
    ).length;
  };

  return (
    <Container>
      <Card>
        <CardContent>
          <div className="header">
            <CardTitle message={'Gestion des avocats'} />
            <SearchBar
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              handlerSearch={props.requestSearchMappingLawyers}
              handlerRefresh={() =>
                props.requestGetMappingLawyers(page, pageSize)
              }
              lawyers={lawyers}
              listings={listings}
            />
          </div>

          <Button
            variant="contained"
            color="primary"
            startIcon={<PersonAddIcon />}
            onClick={() => setAddDialogAddIntervenant(true)}
          >
            {translate(messages.intervernantTableTitle, props)}
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ marginRight: 12 }}
            startIcon={<PersonAddIcon />}
            onClick={() => setOpenDrawerAdd(true)}
          >
            {translate(messages.intervenantTitle, props)}
          </Button>
          <div>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left" className="headerTitle">
                    {translate(messages.jurisdictionTableTitle, props)}
                  </TableCell>
                  <TableCell align="left" className="headerTitle">
                    {translate(messages.intervernantTableTitle, props)}
                  </TableCell>
                  <TableCell align="left" className="headerTitle">
                    {translate(messages.timeIntervalTitle, props)}
                  </TableCell>
                  <TableCell align="left" className="headerTitle">
                    {translate(messages.totalDaysTitle, props)}
                  </TableCell>
                  <TableCell align="left" className="headerTitle">
                    {translate(messages.actionTitle, props)}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {get(
                  mappingLawyers,
                  'mappingLawyerJurisdiction.mappings',
                  [],
                ).map((row: any) => (
                  <TableRow key={row.id}>
                    <TableCell align="left" className="row">
                      {get(row, 'jurisdiction.title', '')}
                    </TableCell>
                    <TableCell align="left" className="row">
                      {!isDesactivateIntervenant(
                        get(listings, 'intervenants'),
                        get(row, 'lawyerCode'),
                      )
                        ? getValueByCode(
                            get(row, 'lawyerCode'),
                            get(listings, 'intervenants', []),
                          )
                        : getValueByCode(
                            get(row, 'lawyerCode'),
                            get(listings, 'inactiveIntervenants', []),
                          ) + ' (Inactif)'}
                    </TableCell>
                    <TableCell align="left" className="row">
                      {getWorkingPeriods(
                        Object.values(formatObject(row) as any),
                      ).map((period, index) => (
                        <span
                          key={index}
                          style={{
                            margin: '2px',
                            padding: '4px 8px',
                            backgroundColor: '#1173ce',
                            color: '#fff',
                            borderRadius: '12px',
                            display: 'inline-block',
                          }}
                        >
                          {period}
                        </span>
                      ))}
                    </TableCell>
                    <TableCell align="left" className="row">
                      {getTotalDays(row) + ' jours'}
                    </TableCell>
                    <TableCell
                      align="left"
                      className="action-row"
                      data-testId="button-action"
                      onClick={() => {
                        setOpenDrawerUpdate(true);
                        setSelectedRow(row);
                      }}
                    >
                      {translate(messages.updateTitle, props)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={ROW_PER_PAGE}
              component="div"
              count={get(mappingLawyers, 'mappingLawyerJurisdiction.count', [])}
              rowsPerPage={pageSize}
              page={page}
              labelRowsPerPage={translate({ ...messages.linesPerPage }, props)}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
            <DrawerUpdateMapping
              listings={listings}
              isDrawerOpen={openDrawerUpdate}
              selectedRow={selectedRow}
              setIsDrawerOpen={setOpenDrawerUpdate}
              requestUpdateMappingLawyers={props.requestUpdateMappingLawyers}
            />
            <DrawerAddMapping
              listings={listings}
              isDrawerOpen={openDrawerAdd}
              selectedRow={selectedRow}
              setIsDrawerOpen={setOpenDrawerAdd}
              requestAddMappingLawyers={props.requestUpdateMappingLawyers}
              requestGetMappingLawyer={props.requestGetMappingLawyer}
              lawyers={corpoLawyers}
              lawyersMapping={get(
                mappingLawyer,
                'mappingLawyerJurisdiction.mappings',
                [],
              )}
            />
            <AddIntervenantDialog
              lawyerOptions={lawyersToAdd}
              disabled={false}
              onClose={handleCloseDialogIntervenant}
              open={openDialogAddIntervenant}
              requestCreateIntervenantKeycloak={
                props.requestCreateIntervenantKeycloak
              }
            />
          </div>
        </CardContent>
      </Card>
    </Container>
  );
};

const mapDispatchToProps = {
  requestGetMappingLawyers,
  requestSetPrivilegesManager,
  requestCorporealLawyers,
  requestCreateIntervenantKeycloak,
  requestUpdateMappingLawyers,
  requestSearchMappingLawyers,
  requestGetMappingLawyer,
};

export default connect(
  null,
  mapDispatchToProps,
)(injectIntl(IntervenantManagement));
